export default __webpack_public_path__ + "static/banner-travel-finance-129b92a318b4acb3530ef62b96060118.jpg";